<template>
    <div class="col-lg-9">
        <div class="d-flex align-items-center mb-4">
            <h4 class="text-7">Create Profile</h4>
            <router-link
                :to="`/business/payments`"
                class="text-decoration-none ml-auto"
            >
                <i class="fas fa-arrow-left"></i> Back to Profiles
            </router-link>
        </div>
        <transition name="shake">
            <p v-if="message && error"
               :class="['alert text-center mb-0 rounded mt-3 px-3 alert-danger']">
                {{ message }}
            </p>
        </transition>

        <div class="reg-form-section ">
            <transition name="slide-in-left">
                <div>
                    <div v-if="stageComplete">
                        <div class="text-center text-white pt-6 mt-6" style="height: 30vw">
                            <transition name="bounce">
                                <div v-if="message && !error">
                                    <check-mark class="p-6"></check-mark>
                                    <h5 class="text-5">{{message}}</h5>
                                </div>
                            </transition>
                        </div>
                    </div>
                    <div v-else>
                        <div class="card card-body border-0">
                            <h6 class="font-weight-bold mb-4">Biller Profile</h6>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label>Status</label>
                                        <select v-model="profileForm.status" class="form-control">
                                            <option selected value="" disabled>-- Select Status--</option>
                                            <option value="PRIVATE">PRIVATE - (Not visible on Magetsi Billers page)</option>
                                            <option value="ACTIVE">PUBLIC - (Visible on Magetsi Billers page) Requires Magetsi Review</option>
                                        </select>
                                        <div v-text="profileForm.errors.get('status')" class="text-danger font-12"/>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label>Biller Logo</label>
                                        <file-upload fileType="image" :aspect-ratio="16/9" v-model="profileForm.logo" :key="'logo-upload'"></file-upload>
                                        <div v-text="profileForm.errors.get('logo')" class="text-danger font-12"/>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label>Featured Image <small>*Optional</small></label>
                                        <file-upload fileType="image" :aspect-ratio="1" v-model="profileForm.display_image" :cropped-image-height="300" :key="'display-upload'"></file-upload>
                                        <div v-text="profileForm.errors.get('display_image')" class="text-danger font-12"/>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label>Biller Name</label>
                                        <input type="text" v-model="profileForm.biller_name" class="form-control" placeholder="Enter your profile name">
                                        <div v-text="profileForm.errors.get('biller_name')" class="text-danger font-12"/>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label>Description</label>
                                        <textarea v-model="profileForm.description" class="form-control" placeholder="Enter a brief description"></textarea>
                                        <div v-text="profileForm.errors.get('description')" class="text-danger font-12"/>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label>Category</label>
                                        <select v-model="profileForm.category" class="form-control">
                                            <option selected value="" disabled>-- Select Category --</option>
                                            <option v-for="c in categories" :key="c" :value="c">{{ c }}</option>
                                        </select>
                                        <div v-text="profileForm.errors.get('category')" class="text-danger font-12"/>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <button
                            class="btn btn-primary btn-block my-4"
                            :class="{ 'btn-loading': loading }"
                            @click="submitCorporateDetails"
                        >
                            Create
                        </button>
                    </div>

                </div>
            </transition>

        </div>

    </div>
</template>

<script>
import Form from "../../../../core/forms/form";
import FileUpload from "../../components/FileUpload.vue";
import StepIndicator from "../../../core/step-indicator.vue";
import Checkmark from "../../../core/Checkmark.vue";

export default {
    name: "Biller",
    components: {CheckMark: Checkmark, StepIndicator, FileUpload },
    data() {
        return {
            stage: 1,
            categories: ["Donations", "Subscriptions", "Invoices", "Utilities", "Fees", "Tickets", "Rentals", "Installments", "Vouchers", "Insurance", "Taxes"],
            profileForm: new Form({
                biller_name: "",
                description: "",
                category: "",
                logo: '',
                display_image: '',
                status:'',
            }),
            agreeToTerms: false,
            stageComplete: false,
            message: "",
            error: false,
            loading: false,
        };
    },
    mounted() {

    },
    methods: {
        async submitCorporateDetails() {
            this.loading = true;
            this.error = false;
            this.message = "";
            this.profileForm
                .upload(`/business/biller-onboarding/profile`)
                .then((response) => {
                    this.stageComplete = true;
                    this.message = response.data.message;
                    if(this.stageComplete === true) {
                        setTimeout(function () {
                            this.stageComplete = false;
                            window.location.href = `/business/payments`;
                            this.message = "";
                        }.bind(this), 3000);
                    }
                    this.loading = false;
                })
                .catch((error) => {
                    this.error = true;
                    this.message = error.response?.data?.message || "Failed to save corporate details.";
                    this.loading = false;
                });
        },
    },
};

</script>
<style scoped>

</style>
